export class BucketNotificationProbeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "transport",
            "baseName": "transport",
            "type": "BucketNotificationTransport",
            "format": ""
        },
        {
            "name": "notificationEndpoint",
            "baseName": "notificationEndpoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "notificationCredentialsSecretArn",
            "baseName": "notificationCredentialsSecretArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "sampleSize",
            "baseName": "sampleSize",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BucketNotificationProbeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
